import React, { useEffect, useRef, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import AuthenticationPage from "../Authentication/AuthenticationPage";
import userOutline from "../../img/navigation/header-user-outline.png";
import userFilled from "../../img/navigation/header-user-filled.png";
import favouriteFilled from "../../img/navigation/header-favourite-filled.png";
import favouriteOutline from "../../img/navigation/header-favorite-outline.png";
import cartFilled from "../../img/navigation/header-cart-filled.png";
import cartOutline from "../../img/navigation/header-cart-outline.png";
import kingLogo from "../../icons/badges/king.png";

import {
  toggleOverlay,
  selectIsOverlayVisible,
} from "../../store/slices/headerSlice";

import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../features/auth/authSlice";

import {
  fetchAllCartsAsync,
  selectAllCarts,
} from "../../features/cartPage/cartPageSlice";
import MiniCart from "./MiniCart";
import { setUser } from "../../features/auth/authSlice";
import LogoutOverlay from "../EndPages/LogoutOverlay";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import { ccHundred } from "../../features/cartPage/walletAPI";
import logoutLogo from "../../assets/Icon-logout-white.svg";
import orderLogo from "../../assets/Icon-orders.svg";
import userLogo from "../../assets/Icon-user.svg";
import wishlistLogo from "../../assets/wishlistLogo.svg";

const HeaderRight = ({ toggleOverlay, isOverlayVisible, setUser }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const profileOptionRef = useRef(null);
  const logoutRef = useRef(null);
  const userDetail = useSelector(selectUser);
  const carts = useSelector(selectAllCarts);
  const userImageUrl = `https://cyclecircle.blr1.cdn.digitaloceanspaces.com/${process.env.REACT_APP_IMAGE_BASE}_USER_IMAGE/${
    userDetail?.UserImage || ""
  }`;

  const [premUser, setPremUser] = useState(false);
  const [openLogout, setOpenLogout] = useState(false);
  const [openProfileOption, setOpenProfileOption] = useState(false);
  const [openMiniCart, setOpenMiniCart] = useState(false);

  const handleProfile = () => {
    setOpenProfileOption(!openProfileOption);
  };

  // Inside the Header component
  useEffect(() => {
    const handleClickOutsideMiniCart = (event) => {
      const miniCart = document.querySelector(".mini-cart-container");
      if (miniCart && !miniCart.contains(event.target)) {
        setOpenMiniCart(false); // Close the MiniCart
      }
    };

    document.addEventListener("mousedown", handleClickOutsideMiniCart);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideMiniCart);
    };
  }, []);

  useEffect(() => {
    if (userDetail && userDetail?.UserID) {
      dispatch(fetchAllCartsAsync(userDetail?.UserID));
    }
  }, [dispatch, userDetail]);

  useEffect(() => {
    const responsePromise = ccHundred(userDetail?.UserID);
    responsePromise
      .then((response) => {
        if (response && response?.data && response?.data?.message) {
          setPremUser(true);
        }
      })
      .catch((error) => {
        // console.error("Error:", error);
        // Handle error if necessary
      });
  }, [userDetail?.UserID]);

  useEffect(() => {
    const handleClickOutsideProfile = (event) => {
      const clickedOutsideProfile =
        profileOptionRef.current &&
        !profileOptionRef.current.contains(event.target);
      const clickedInsideLogout =
        logoutRef.current && logoutRef.current.contains(event.target);

      if (clickedOutsideProfile && !clickedInsideLogout) {
        setOpenProfileOption(false);
      }
    };

    if (openProfileOption) {
      document.addEventListener("mousedown", handleClickOutsideProfile);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideProfile);
    };
  }, [openProfileOption]);

  const navigateURL = (url) => {
    navigate(url);
  };

  const handleOpenLogout = () => {
    setOpenLogout(!openLogout);
  };

  const handleWishlist = () => {
    if (Object.keys(userDetail).length) {
      navigate("/wishlist");
    } else {
      toggleOverlay();
    }
  };
  const handleCart = () => {
    if (Object.keys(userDetail).length > 0) {
      if (location.pathname !== "/carts") {
        setOpenMiniCart(!openMiniCart);
      }
    } else {
      toggleOverlay();
    }
  };

  return (
    <>
      <div className="flex items-center justify-between w-[13%]">
        {/* User Profile */}
        <div className="relative flex items-center justify-center w-1/5 py-[3.2vh]">
          {userDetail?.UserID ? (
            <img
              src={userImageUrl}
              alt={userDetail?.UserImage || ""}
              onClick={handleProfile}
              className="w-[2.2vw] h-[2.2vw] rounded-full bg-white-1 cursor-pointer hover:scale-105 transition-transform duration-300"
            />
          ) : (
            <img
              src={userOutline}
              alt="User"
              className="w-[1.7vw] h-[1.7vw] cursor-pointer text-white-1 hover:scale-110 transition-transform duration-300"
              onClick={handleProfile}
              onMouseOver={(e) => (e.currentTarget.src = userFilled)}
              onMouseOut={(e) => (e.currentTarget.src = userOutline)}
            />
          )}

          {/* Profile Dropdown */}
          {openProfileOption && (
            <div
              ref={profileOptionRef}
              className="absolute right-0 top-full w-60 bg-white-1 shadow-xl rounded-xl border border-gray-200 overflow-hidden z-50 transition-all duration-300 ease-in-out"
            >
              {/* User Info */}
              <div className="flex items-center px-4 py-3 border-b border-gray-100">
                {userDetail?.UserID ? (
                  <>
                    <img
                      src={userImageUrl}
                      alt={userDetail?.UserImage || ""}
                      className="w-12 h-12 rounded-full object-cover border-2 border-orange-400 transition-transform duration-300 hover:scale-105"
                    />
                    <div className="ml-3 flex flex-col">
                      <span className="font-semibold text-gray-800 hover:text-orange-500 transition-colors duration-300">
                        {userDetail?.FirstName} {userDetail?.LastName}
                      </span>
                      <span className="text-sm text-gray-500 hover:text-orange-400 transition-colors duration-300">
                        {userDetail?.Email || ""}
                      </span>
                    </div>
                  </>
                ) : (
                  <div className="flex items-center space-x-2">
                    <PersonAddAltOutlinedIcon className="text-gray-500 cursor-pointer hover:text-orange-500 transition-transform duration-300 hover:scale-110" />
                    <span
                      className="text-sm font-medium text-gray-600 cursor-pointer hover:text-orange-500 transition-colors duration-300"
                      onClick={toggleOverlay}
                    >
                      Login / Sign Up
                    </span>
                  </div>
                )}
              </div>

              {/* Menu Options */}
              <div className="flex flex-col pt-2">
                {premUser && (
                  <div
                    className="flex items-center px-4 py-2.5 rounded-lg hover:bg-orange-400-50 cursor-pointer transition-all duration-300 transform hover:translate-x-1 hover:shadow-md"
                    onClick={() => {
                      userDetail?.UserID
                        ? navigateURL("/admin/dashboard")
                        : toggleOverlay();
                      setOpenProfileOption(false);
                    }}
                  >
                    <img src={kingLogo} alt="" className="w-6 h-6 mr-3" />
                    <span className="font-medium text-gray-700 whitespace-nowrap">
                      Admin Dashboard
                    </span>
                  </div>
                )}

                {[
                  {
                    label: "My Profile",
                    icon: userLogo,
                    link: "/user/profile",
                  },
                  { label: "Orders", icon: orderLogo, link: "/user/orders" },
                  { label: "Wishlist", icon: wishlistLogo, link: "/wishlist" },
                ].map(({ label, icon, link }) => (
                  <div
                    key={label}
                    className="flex items-center px-4 py-2.5 rounded-lg hover:bg-orange-50 cursor-pointer transition-all duration-300 transform hover:translate-x-1 hover:shadow-md"
                    onClick={() => {
                      userDetail?.UserID ? navigateURL(link) : toggleOverlay();
                      setOpenProfileOption(false);
                    }}
                  >
                    <img src={icon} alt={label} className="w-6 h-6 mr-3" />
                    <span className="font-medium text-gray-700">{label}</span>
                  </div>
                ))}

                {userDetail?.UserID && (
                  <div
                    className="flex items-center px-4 py-2 rounded-lg bg-peach cursor-pointer hover:scale-105 hover:shadow-lg transition-all duration-300"
                    onClick={handleOpenLogout}
                  >
                    <img
                      src={logoutLogo}
                      alt="Logout"
                      className="w-6 h-6 mr-3"
                    />
                    <span className="font-medium text-white-1">Logout</span>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Logout Overlay outside */}
          {openLogout && (
            <LogoutOverlay
              openLogout={openLogout}
              handleOpenLogout={handleOpenLogout}
              logoutRef={logoutRef} // 👈 pass the ref here
            />
          )}
        </div>

        {/* Wishlist */}
        <div className="flex items-center justify-center w-1/5 py-[3.2vh]">
          <img
            src={
              location.pathname === "/wishlist"
                ? favouriteFilled
                : favouriteOutline
            }
            alt="Wishlist"
            className="w-[1.9vw] cursor-pointer text-white transition-all duration-100 hover:w-[2.1vw]"
            onClick={handleWishlist}
          />
        </div>

        {/* Cart */}
        <div
          className="relative flex items-center justify-center w-1/5 py-[3.2vh] cursor-pointer"
          onClick={handleCart}
        >
          <img
            src={cartOutline}
            alt="Cart"
            className="w-[1.9vw] cursor-pointer text-white transition-all duration-100 hover:w-[2.1vw]"
            onMouseOver={(e) => (e.currentTarget.src = cartFilled)}
            onMouseOut={(e) => (e.currentTarget.src = cartOutline)}
          />
          {carts?.length > 0 && userDetail?.UserID && (
            <sup className="absolute top-3 -right-2 w-6 h-6 flex items-center justify-center rounded-full bg-orange-500 text-white-1 text-sm">
              {carts.length}
            </sup>
          )}
          {openMiniCart && (
            <MiniCart isOpen={openMiniCart} onClose={setOpenMiniCart} />
          )}
        </div>
      </div>

      {/* Authentication Overlay */}
      {isOverlayVisible && (
        <div className="fixed inset-0 w-full h-full bg-black/50 flex items-center justify-center z-[1000]">
          <AuthenticationPage />
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  isOverlayVisible: selectIsOverlayVisible(state),
  user: state.user,
});
const mapDispatchToProps = {
  toggleOverlay,
  setUser,
};
export default connect(mapStateToProps, mapDispatchToProps)(HeaderRight);
